<template>
    <Badge :lbl="params.value" v-bind="params.data" />
</template>
<script>
import Badge from '../../atoms/visuals/Badge.vue';

export default {
    name: 'mead-ag-grid-badge',
    components: {Badge}
}
</script>